import { dispatcher, api } from '@unicus/react-ui-kit';

export const COLLABORATOR = 'COLLABORATOR';

export const COLLABORATOR_INVITATION_RESEND = 'COLLABORATOR_INVITATION_RESEND';
export const COLLABORATOR_INVITATION_RESEND_FINISHED =
  'COLLABORATOR_INVITATION_RESEND_FINISHED';

export const COLLABORATOR_CHANGE_INACTIVATE = 'COLLABORATOR_CHANGE_INACTIVATE';
export const COLLABORATOR_CHANGE_INACTIVATE_FINISHED =
  'COLLABORATOR_CHANGE_INACTIVATE_FINISHED';

export const resendInvitation = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'collaborators/invitations',
    actionType: COLLABORATOR_INVITATION_RESEND,
    effect: async () => api.put(`collaborators/invitations/${id}/resend`),
    onSuccess
  });
};

export const inactivate = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'collaborators',
    actionType: COLLABORATOR_CHANGE_INACTIVATE,
    effect: async () => api.put(`collaborators/${id}/inactivate`),
    onSuccess
  });
};

export const activate = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'collaborators',
    actionType: COLLABORATOR_CHANGE_INACTIVATE,
    effect: async () => api.put(`collaborators/${id}/activate`),
    onSuccess
  });
};
